<h1 mat-dialog-title class="with-icon" style="margin-left: 30%">
  <mat-icon color="warn">error</mat-icon>{{viewErrorTitle}}
</h1>
<mat-dialog-content style="height: 200px">
  <div *ngIf="currentView === 'success'">
    <div>success Message</div>
  </div>

  <div *ngIf="currentView === 'error'">
    <div style="margin-top: 5%">
      <mat-card class="example-card">
        <mat-card-content class="Parent" *ngFor="let view of viewData">
          <mat-list>
            <mat-list-item class="with-icon">
              <span class="item-icon">
                <mat-icon *ngIf="view.messageType === 1">info</mat-icon>
                <mat-icon *ngIf="view.messageType === 2">error</mat-icon>
                <mat-icon *ngIf="view.messageType === 4">warning</mat-icon>
              </span>
              <span class="item-title">
                <strong>{{view.code}}</strong>
              </span>
              <span class="item-desc"> {{view.message}} </span>
            </mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button color="primary" (click)="onNoClick()">close</button>
</mat-dialog-actions>
